
import React from 'react';

const SecuredFormattedMessageWrapper = ({ children }) => {

    // TODO: make the Wrapper to deal with chunks of nested children and detect the parent Component where the issue happened

    const wrapperName = '=SecuredFormattedMessageWrapper=';

    if(!children) {
        console.log(`Children haven't been provided in ${wrapperName}`);
        return null;
    }

    if(React.Children.count(children) > 1) {
        console.log(`More than 1 child has been passed to ${wrapperName}`);
        return null;
    }

    if(!children.props) {
        console.log(`Text node has been passed to ${wrapperName}`);
        return children;
    }

    const {
        type: {
            displayName: elementName
        },
        props: {
            id,
            ...restChildrenProps
        }
    } = children;

    if(elementName !== 'FormattedMessage'){
        console.log(`Not a =FormattedMessage= wrapped with ${wrapperName}`);
        return children;
    }

    const isExpectedPayload = typeof id === 'string' && id !== '';

    const representId = id => {
        switch(id) {
            case null:
                return '=null=';
            case undefined:
                return '=undefined=';
            case '':
                return '=empty string=';
            default:
                return JSON.stringify(id);

        }
    };

    if(!isExpectedPayload) {
        console.log(`Not an eligible id value [ actually: ${ representId(id) } ] has been provided to =FormattedMessage= Component`);
    }

    return (
        React.cloneElement(children, {
            ...(!isExpectedPayload ? { id: 'common.no_text' } : { id }),
            ...restChildrenProps
        } )
    );
};

export default SecuredFormattedMessageWrapper;